import React, { PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Flex from './Flex'

export default function Breadcrumps({ items }: Props) {
    return (
        <BreadcrumpsWrapper>
            {items.map((item, idx) => {
                const last = (items.length - 1) === idx

                if (item.url)
                    return <BreadcrumpsItem key={idx} last={last}><Link to={item.url}>{item.name}</Link></BreadcrumpsItem>
                
                return <BreadcrumpsItem key={idx} last={last}><span>{item.name}</span></BreadcrumpsItem>
            })}
        </BreadcrumpsWrapper>
    )
}

function BreadcrumpsItem({ children, last }: PropsWithChildren<{ last: boolean }>) {
    return (
        <li><h4>{children}{last || <Divider>—</Divider>}</h4></li>
    )
}

const BreadcrumpsWrapper = styled.ul`
    display: flex;
    flex-wrap: wrap;
    margin: -3px 0;

    li {
        list-style-type:none;
        padding:0;
        margin: 3px 0;

        &:first-child {
            margin: 3px 0;
        }
    }
`

const Divider = styled.span`
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
`

interface Props {
    items: { name: string, url?: string }[]
}